import { awaitAllSafely } from '@vy/utils';
import type { Control } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { usePaddleConnect } from '../../../../../../hooks/requests/integrations';
import { queryKeys } from '../../../../../../services/query-key/query-keys';
import { runMutation } from '../../../../../../utils/vy-mutation';
import type { PaddleConfigurationFormValues } from '../configure-paddle-integration/PaddleConfigurationFormSchema';
import type { PaddleRegisterFormValues } from '../register-to-paddle/PaddleRegisterFormSchema';

export const useConnectToPaddle = (
  control: Control<PaddleRegisterFormValues | PaddleConfigurationFormValues>,
) => {
  const queryClient = useQueryClient();
  const { setError } = control;
  const mutateAsyncPaddleConnect = usePaddleConnect();

  return (apiToken: string, environment: 'sandbox' | 'production') =>
    runMutation(
      mutateAsyncPaddleConnect,
      { apiToken, environment },
      {
        pending: 'Connecting...',
        success: 'Connected',
        error: 'Failed to connect',
      },
      {
        onError: () => {
          setError('apiToken', {
            type: 'manual',
            message: 'Invalid API token',
          });
        },
        onSuccess: () =>
          awaitAllSafely(
            queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
            queryClient.invalidateQueries(queryKeys.integrationSettings()),
          ),
      },
    );
};
